import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { useState } from "react";
import { API_ENDPOINTS } from "../../../constants/api_endpoints";
import { QData } from "../../../types/basic-type-list";
import { TResponse, TResponseWithQData } from "../../../types/common";
import { dashboardStats, detailUser, listUser } from "./callbacks";
import { IAppUserPayload, IDashboardStats } from "../../../types/api/app-user";

export const useListUser = (
  qData: QData,
  options?: Omit<
    UseQueryOptions<TResponseWithQData<IAppUserPayload[]>, Error>,
    "queryKey" | "queryFn"
  >
): UseQueryResult<TResponseWithQData<IAppUserPayload[]>, Error> & {
  refetchWithQuery: (params: Partial<QData>) => void;
} => {
  const [queryParams, setQueryParams] = useState<QData>({ ...qData });

  const queryResult = useQuery<TResponseWithQData<IAppUserPayload[]>, Error>({
    queryKey: [API_ENDPOINTS.USER_LIST, { ...queryParams, total: null }],
    queryFn: async () => {
      const res = await listUser(queryParams);
      return res.data;
    },
    select: (res) => ({
      ...res,
      data: res.data.map((x) => ({ key: x._id, ...x })),
      qData: { ...queryParams, total: res.extra?.total },
    }),
    staleTime: 300000,
    initialDataUpdatedAt: 0,
    refetchOnWindowFocus: true,
    ...options,
  });

  return {
    ...queryResult,
    refetchWithQuery: (params: Partial<QData>) => {
      setQueryParams((prev: any) => ({ ...prev, ...params }));
    },
  };
};

export const useUserDetail = (
  id: string,
  options?: Omit<
    UseQueryOptions<TResponse<IAppUserPayload>, Error>,
    "queryKey" | "queryFn"
  >
): UseQueryResult<TResponse<IAppUserPayload>, Error> => {
  return useQuery<TResponse<IAppUserPayload>, Error>({
    queryKey: [API_ENDPOINTS.USER_DETAIL, id],
    queryFn: async () => {
      const res = await detailUser(id);
      return res.data;
    },
    enabled: !!id,
    refetchOnWindowFocus: false,
    staleTime: 300000,
    ...options,
  });
};

export const useGetDashboardStats = (
  options?: Omit<
    UseQueryOptions<TResponse<IDashboardStats>, Error>,
    "queryKey" | "queryFn"
  >
): UseQueryResult<TResponse<IDashboardStats>, Error> => {
  return useQuery<TResponse<IDashboardStats>, Error>({
    queryKey: [API_ENDPOINTS.DASHBOARD_STATS],
    queryFn: async () => {
      const res = await dashboardStats();
      return res.data;
    },
    refetchOnWindowFocus: false,
    staleTime: 10000,
    ...options,
  });
};

// export const useServiceDelete = (
//   { qData = { page: 1, limit: 20 }, onSuccess, onError }: {
//     qData?: QData;
//     onSuccess?: (res: TResponse<IDeleteDataResponseAndPayload>) => void;
//     onError?: (error: unknown) => void;
//   }
//   ,
//   options: UseMutationOptions<TResponse<IDeleteDataResponseAndPayload>, unknown, IDeleteDataResponseAndPayload> = {}
// ): UseMutationResult<TResponse<IDeleteDataResponseAndPayload>, unknown, IDeleteDataResponseAndPayload> => {
//   const queryClient = useQueryClient();

//   return useMutation<TResponse<IDeleteDataResponseAndPayload>, unknown, IDeleteDataResponseAndPayload>({
//     mutationFn: async (data: IDeleteDataResponseAndPayload) => {
//       const response = await deleteService(data);
//       return response.data;
//     },
//     onSuccess: (res: TResponse<IDeleteDataResponseAndPayload>, ...rest) => {
//       console.log(API_ENDPOINTS.SERVICE_LIST, { ...qData, total: null })
//       console.log(res,"res-delete")
//       queryClient.setQueryData([API_ENDPOINTS.SERVICE_LIST, { ...qData, total: null }], (old: TResponse<IDeleteDataResponseAndPayload[]>) => {
//         if (!old) return;
//         return {
//           ...old,
//           data: Array.isArray(res.data.ids) ? old.data.filter((v: any) => ~res.data.ids.includes(v._id)) : old.data.filter((v: any) => res.data.ids !== v._id),
//         };
//       });

//       onSuccess?.(res);
//       options?.onSuccess?.(res, ...rest);
//     },
//     onError: (error, ...rest) => {
//       onError?.(error);
//       options?.onError?.(error, ...rest);
//     },
//     ...options
//   });
// };
